"use strict";

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
export const formatPhoneNumberAU = (phoneNumber = '', addCountryCode = false) => {
  let trimmed = phoneNumber.replace(/^(\+61|\(|\)|00)/g, '').trim();
  if (/^(1300|1800)/.test(trimmed)) {
    const start = trimmed.slice(0, 4);
    const rest = trimmed.slice(4, trimmed.length);
    return `${start} ${rest.replace(/(\d{3})/, '$1 ').replace(/\s\(d{1}\)\s/g, '$1 ').replace(/(^\s+|\s+$)/, '')}`;
  }
  if (trimmed.length > 9) {
    trimmed = trimmed.replace(/(\d{4})/, '$1 ');
  }
  return (addCountryCode ? '(+61) ' : '') + trimmed.replace(/(\d{3})/g, '$1 ').replace(/\s\(d{1}\)\s/g, '$1 ').replace(/(^\s+|\s+$)/, '').padStart(addCountryCode ? 11 : 12, '0');
};